function shouldSkipDuplicateClick(touchHandled) {
  return touchHandled === true;
}

function resolveKeyboardAction(action) {
  if (!action) {
    return null;
  }

  if (action === 'del') {
    return { type: 'del' };
  }

  if (action === '00') {
    return { type: 'append', value: '00' };
  }

  if (action === 'max') {
    return { type: 'max' };
  }

  if (action === 'min') {
    return { type: 'min' };
  }

  if (/^\d$/.test(action)) {
    return { type: 'digit', value: action };
  }

  if (action.indexOf('add:') === 0) {
    return { type: 'add', value: parseInt(action.split(':')[1], 10) };
  }

  return null;
}

function normalizeStakeString(currentStake) {
  if (currentStake == null || currentStake === undefined || currentStake === '') {
    return '';
  }

  return currentStake.toString();
}

function canAppendZeroToStake(current) {
  return current !== '' && current !== '0';
}

function appendStakeDigit(currentStake, digit) {
  const current = normalizeStakeString(currentStake);
  const digitStr = digit.toString();

  if (digitStr === '0') {
    if (!canAppendZeroToStake(current)) {
      return current;
    }

    return current + '0';
  }

  if (current === '' || current === '0') {
    return digitStr;
  }

  return current + digitStr;
}

function appendStakeSuffixToValue(currentStake, suffix) {
  const current = normalizeStakeString(currentStake);

  if (suffix === '00' && !canAppendZeroToStake(current)) {
    return current;
  }

  if (!canAppendZeroToStake(current) && /^0+$/.test(suffix)) {
    return current;
  }

  return current + suffix;
}

function isStakeAtOrAboveMax(currentStake, maxBet) {
  if (maxBet == null || maxBet === undefined || isNaN(maxBet)) {
    return false;
  }

  if (currentStake == null || currentStake === undefined || currentStake === '') {
    return false;
  }

  const current = parseInt(currentStake.toString(), 10);

  return !isNaN(current) && current >= maxBet;
}

function applyFastStakeIncrement(currentStake, amount, maxBet) {
  const increment = parseInt(amount, 10);
  if (isNaN(increment)) {
    return normalizeStakeString(currentStake);
  }

  if (maxBet == null || maxBet === undefined || isNaN(maxBet)) {
    const current = normalizeStakeString(currentStake);
    if (current === '') {
      return increment.toString();
    }

    const numeric = parseInt(current, 10);
    if (isNaN(numeric)) {
      return increment.toString();
    }

    return (numeric + increment).toString();
  }

  const max = parseInt(maxBet, 10);
  const current = normalizeStakeString(currentStake);

  if (current === '') {
    return increment > max ? max.toString() : increment.toString();
  }

  const numeric = parseInt(current, 10);
  if (isNaN(numeric)) {
    return increment > max ? max.toString() : increment.toString();
  }

  if (numeric >= max) {
    return max.toString();
  }

  const next = numeric + increment;
  return next > max ? max.toString() : next.toString();
}

function preventTouchDefault(event) {
  if (event && event.cancelable) {
    event.preventDefault();
  }
}

function findKeyboardButton(target, keyboard) {
  if (!target || !keyboard) {
    return null;
  }

  const button = target.closest('.button-tap, .add-stake');
  if (!button || !keyboard.contains(button)) {
    return null;
  }

  return button;
}

export default {
  data() {
    return {
      _keyboardTouchHandled: false,
      _keyboardTouchHandledTimer: null,
      _keyboardGuardUntil: 0
    };
  },
  beforeDestroy() {
    clearTimeout(this._keyboardTouchHandledTimer);
  },
  computed: {
    showStakeCancel() {
      const stake = this.stake;

      return stake != null && stake !== undefined && stake !== '';
    }
  },
  methods: {
    isStakeValidForBet() {
      const stake = this.stake;

      if (stake == null || stake === undefined || stake === '') {
        return false;
      }

      const numeric = parseInt(stake.toString(), 10);

      return !isNaN(numeric) && numeric > 0;
    },
    rejectBetWithFeedback(statusKey) {
      this.loading.process = false;
      this.betConfirm = false;
      this.$helpers.handleFeedback(statusKey);
    },
    getBetMinStake() {
      if (this.minBet != null && this.minBet !== undefined) {
        return parseInt(this.minBet, 10);
      }

      if (this.betsingle && this.betsingle.minBet != null && this.betsingle.minBet !== undefined) {
        return parseInt(this.betsingle.minBet, 10);
      }

      if (this.betsinglemmo && this.betsinglemmo.minBet != null && this.betsinglemmo.minBet !== undefined) {
        return parseInt(this.betsinglemmo.minBet, 10);
      }

      return null;
    },
    getBetMaxStake() {
      if (this.maxBet != null && this.maxBet !== undefined) {
        return parseInt(this.maxBet, 10);
      }

      if (this.betsingle && this.betsingle.maxBet != null && this.betsingle.maxBet !== undefined) {
        return parseInt(this.betsingle.maxBet, 10);
      }

      if (this.betsinglemmo && this.betsinglemmo.maxBet != null && this.betsinglemmo.maxBet !== undefined) {
        return parseInt(this.betsinglemmo.maxBet, 10);
      }

      return null;
    },
    rejectStakeLimitViolation(limitType) {
      const min = this.getBetMinStake();
      const max = this.getBetMaxStake();

      this.loading.process = false;
      this.betConfirm = false;

      if (limitType === 'min' && min != null && !isNaN(min)) {
        this.stake = min;
        if (typeof this.handleStake === 'function') {
          this.handleStake();
        }
        if (typeof this.errorMessage !== 'undefined') {
          this.errorMessage = this.$t('error.betLowerMin');
        }
        this.$nextTick(() => {
          if (!this.$el) {
            return;
          }
          const errorNode = this.$refs.limitErrorNotice || this.$el.querySelector('.odds-change-notice');
          if (errorNode && typeof errorNode.scrollIntoView === 'function') {
            errorNode.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
        return false;
      }

      if (limitType === 'max' && max != null && !isNaN(max)) {
        this.stake = max;
        if (typeof this.handleStake === 'function') {
          this.handleStake();
        }
        if (typeof this.errorMessage !== 'undefined') {
          this.errorMessage = this.$t('error.betOverMaxBet');
        }
        this.$nextTick(() => {
          if (!this.$el) {
            return;
          }
          const errorNode = this.$refs.limitErrorNotice || this.$el.querySelector('.odds-change-notice');
          if (errorNode && typeof errorNode.scrollIntoView === 'function') {
            errorNode.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
        return false;
      }

      return false;
    },
    validateStakeForPlaceBet() {
      if (!this.isStakeValidForBet()) {
        if (typeof this.errorMessage !== 'undefined') {
          this.errorMessage = '';
        }
        this.rejectBetWithFeedback('betAmountRequired');
        return false;
      }

      const numeric = parseInt(this.stake.toString(), 10);
      const min = this.getBetMinStake();
      const max = this.getBetMaxStake();

      if (min != null && !isNaN(min) && numeric < min) {
        return this.rejectStakeLimitViolation('min');
      }

      if (max != null && !isNaN(max) && numeric > max) {
        return this.rejectStakeLimitViolation('max');
      }

      if (typeof this.errorMessage !== 'undefined') {
        this.errorMessage = '';
      }

      return true;
    },
    showKeyboard() {
      if (!this.$el) {
        return;
      }

      $(this.$el).find('.keyboard').show().css('display', 'block');
    },
    armKeyboardGuard(durationMs) {
      this._keyboardGuardUntil = Date.now() + (durationMs || 400);
    },
    isKeyboardGuarded() {
      return this._keyboardGuardUntil > Date.now();
    },
    markKeyboardTouchHandled() {
      this._keyboardTouchHandled = true;
      clearTimeout(this._keyboardTouchHandledTimer);
      this._keyboardTouchHandledTimer = setTimeout(() => {
        this._keyboardTouchHandled = false;
      }, 400);
    },
    handleKeyboardInteraction(event) {
      const button = findKeyboardButton(event.target, event.currentTarget);
      if (!button) {
        return;
      }

      if (event.type === 'touchend') {
        preventTouchDefault(event);
        this.markKeyboardTouchHandled();
        this.runKeyboardAction(button);
        return;
      }

      if (event.type === 'click') {
        if (shouldSkipDuplicateClick(this._keyboardTouchHandled)) {
          this._keyboardTouchHandled = false;
          return;
        }
        this.runKeyboardAction(button);
      }
    },
    runTapAction(actionFn, event) {
      if (event && event.type === 'touchend') {
        preventTouchDefault(event);
        this.markKeyboardTouchHandled();
        actionFn();
        return;
      }

      if (event && event.type === 'click' && shouldSkipDuplicateClick(this._keyboardTouchHandled)) {
        this._keyboardTouchHandled = false;
        return;
      }

      actionFn();
    },
    runKeyboardAction(button) {
      const resolved = resolveKeyboardAction(button.getAttribute('data-kb'));
      if (!resolved) {
        return;
      }

      switch (resolved.type) {
        case 'digit':
          this.keyStake(resolved.value);
          break;
        case 'del':
          this.deleteStake();
          break;
        case 'append':
          this.appendStakeSuffix(resolved.value);
          break;
        case 'add':
          this.fastStake(resolved.value);
          break;
        case 'max':
          this.maxStake();
          break;
        case 'min':
          this.minStake();
          break;
        default:
          break;
      }
    },
    getKeyboardMaxBet() {
      return this.getBetMaxStake();
    },
    fastStake(amount) {
      if (!!this.stopBet) {
        return;
      }

      const max = this.getBetMaxStake();
      this.stake = applyFastStakeIncrement(this.stake, amount, max);

      if (typeof this.handleStake === 'function') {
        this.handleStake();
      }
    },
    getStakeString() {
      if (this.stake == null || this.stake === undefined || this.stake === '') {
        return '';
      }

      return this.stake.toString();
    },
    buildStakeFromDigit(digit) {
      if (!!this.stopBet) {
        return this.stake;
      }

      return appendStakeDigit(this.stake, digit);
    },
    appendStakeSuffix(suffix) {
      if (!!this.stopBet) {
        return;
      }

      this.stake = appendStakeSuffixToValue(this.stake, suffix);
    }
  }
};
